import { Fragment, useState } from 'react';
import { Menu, Transition } from '@headlessui/react';
import { useNavigate } from "react-router-dom";
import Cookies from 'js-cookie';
// import { ChevronDownIcon } from '@heroicons/react/solid'

function classNames(...classes) {
  return classes.filter(Boolean).join(' ')
}

export default function Dropdown(props) {

  const navigate = useNavigate();
  
  const logout = () => {
    console.log("Logging OUT")
    localStorage.removeItem('UserEmail');
    localStorage.removeItem('Role');
    Cookies.remove('token');
    setNav(true);
    navigate('/')
  }

  const saveSettings = () => {
    console.log("SAVING Settings");
    console.log(props.state);
    let cookieName = 'cardSettings' + props.system;
    Cookies.set(cookieName, JSON.stringify(props.state), {expires: 100});
    localStorage.setItem(cookieName, JSON.stringify(props.state));
    return;
  }

  const resetSettings = () => {
    let allSystems = ['PV', 'OP', 'SP', 'IP', 'KYOP'];
    for (let i=0; i < allSystems.length; i++) {
      let name = 'cardSettings' + allSystems[i];
      //console.log(name)
      Cookies.remove(name);
      localStorage.removeItem(name);
    }
    return;
  }

  const [nav, setNav] = useState(false);

  return (
    <Menu as="div" className="relative inline-block text-left z-10 mr-2">
      <div>
        <Menu.Button className="inline-flex justify-center w-full rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-sm font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-100 focus:ring-indigo-500">
          Options
          {/* <ChevronDownIcon className="-mr-1 ml-2 h-5 w-5" aria-hidden="true" /> */}
        </Menu.Button>
      </div>

      <Transition
        as={Fragment}
        enter="transition ease-out duration-100"
        enterFrom="transform opacity-0 scale-95"
        enterTo="transform opacity-100 scale-100"
        leave="transition ease-in duration-75"
        leaveFrom="transform opacity-100 scale-100"
        leaveTo="transform opacity-0 scale-95"
      >
        <Menu.Items className="origin-top-right absolute right-0 mt-2 w-56 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 focus:outline-none">
          <div className="py-1">
            {/* <Menu.Item>
              {({ active }) => (
                <a
                  href="#"
                  className={classNames(
                    active ? 'bg-gray-100 text-gray-900' : 'text-gray-700',
                    'block px-4 py-2 text-sm'
                  )}
                >
                  Account settings
                </a>
              )}
                  </Menu.Item> */}
            
            <form onSubmit={logout}>
              <Menu.Item>
                {({ active }) => (
                  <button
                    type="submit"
                    className={classNames(
                      active ? 'bg-gray-100 text-gray-900' : 'text-gray-700',
                      'block w-full text-left px-4 py-2 text-sm'
                    )}
                  >
                    Sign out
                  </button>
                )}
              </Menu.Item>
            </form>

            {props.system !== '' ? (<form onSubmit={saveSettings}>
              <Menu.Item>
                {({ active }) => (
                  <button
                    type="submit"
                    className={classNames(
                      active ? 'bg-gray-100 text-gray-900' : 'text-gray-700',
                      'block w-full text-left px-4 py-2 text-sm'
                    )}
                  >
                    Save Settings
                  </button>
                )}
              </Menu.Item>
            </form> ) : null}

            {props.system !== '' ? (<form onSubmit={resetSettings}>
              <Menu.Item>
                {({ active }) => (
                  <button
                    type="submit"
                    className={classNames(
                      active ? 'bg-gray-100 text-gray-900' : 'text-gray-700',
                      'block w-full text-left px-4 py-2 text-sm'
                    )}
                  >
                    Reset Settings
                  </button>
                )}
              </Menu.Item>
            </form> ) : null}
          </div>
        </Menu.Items>
      </Transition>
    </Menu>
  )
}
